import { createStore, compose } from 'redux'
import rootReducers from './Reducers'
import { createBrowserHistory } from 'history'

export const history = createBrowserHistory()
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export const store = createStore(
  rootReducers(history),
  composeEnhancers()
)

export default store
